import * as React from 'react';
import { MapContext } from '../Map';
import useBindEvents from '../../hooks/useBindEvents';
import { Events } from '../../types';
// tslint:disable-next-line: no-var-requires
require('./assets/marker.less');

const {
  useContext, useEffect, useState, memo, useImperativeHandle,
} = React;

export interface MarkerOptions {
  // position: any; // AMap.LocationValue[] | AMap.LocationValue[][] | undefined;
  [option: string]: any;
}

export interface PolylineOptions {
  path: any;
  [option: string]: any;
}

export interface PassedLineOptions {
  [option: string]: any;
}

export interface TrackHistoryProps {
  markerOptions: MarkerOptions;
  markerEvents?: Events;
  markerHoverLabel?: any;
  [option: string]: any;
  polylineOptions: PolylineOptions;
  passedLineOptions?: PassedLineOptions;
  speed: number; // km／h
  /** 是否显示label */
  showTrackLabel?: boolean;
  trackLabelOptions?: any;
  timeOptions?: any;
  speedScale: number;
  isPlayBack?: boolean;
  /** 监听moving中的path索引，传给callback */
  onMoving?: (currentIndex?: number) => {};
  /** 是否支持lable可点击 */
  labelCloseable?: boolean;
}

const TrackHistory = React.forwardRef((props: TrackHistoryProps, ref: any) => {
  const { markerOptions, markerEvents, polylineOptions, passedLineOptions, trackLabelOptions,
    showTrackLabel, timeOptions, speedScale, isPlayBack, labelCloseable } = props;

  const map = useContext(MapContext);
  const [marker, setMarker]: [any, any] = useState(null);
  const [polyline, setPolyline]: [any, any] = useState(null);
  const [passedPolyline, setPassedPolyline]: [any, any] = useState(null);

  useBindEvents(marker, markerEvents);

  useEffect(() => {
    if (!map) {
      return;
    }

    marker && (map as unknown as AMap.Map).remove([marker]);
    polyline && (map as unknown as AMap.Map).remove([polyline]);
    passedPolyline && (map as unknown as AMap.Map).remove([passedPolyline]);

    const { offset } = markerOptions;
    const markerOffset = offset ? new AMap.Pixel(offset[0], offset[1]) : new AMap.Pixel(-10, -34);
    const { path } = polylineOptions;

    /** 改变轨迹回访进度时已经走过的坐标点组 */
    let changePassedPath: any = [];
    /** 当前lable显示内容 */
    let currentLable: any = null;
    /** 当前lable显示状态 */
    let isOpenLable: any = !labelCloseable;

    const newMarker = new AMap.Marker({
      offset: markerOffset,
      autoRotation: true,
      angle: -90,
      ...markerOptions,
      position: path.length ? path[0] : [116.478935,39.997761],
    });

    const newPolyline = new AMap.Polyline({
      path,
      showDir: true,
      strokeColor: "#28F",
      strokeWeight: 6,
      ...polylineOptions,
    });

    const newPassedPolyline = new AMap.Polyline({
      strokeColor: "#AF5", 
      strokeWeight: 6,
      ...passedLineOptions || {},
    });
    /** 回到起点, 传递索引、改变起点label、重画newPassedPolyline、规划路线 */
    const handleReturnStart = () => {
      props.onMoving && props.onMoving(0);

      currentLable = {
        ...trackLabelOptions || {},
        content: `${timeOptions[0]}`,
        offset: markerOffset,
      };
      !labelCloseable && showTrackLabel && newMarker.setLabel(currentLable);

      changePassedPath = [];
      newPassedPolyline.setPath([]);

      newMarker.moveAlong(path, props.speed * speedScale);
    };
    
    /**监听点击lable显示隐藏 */
    newMarker.on('click', function (e) {
      if (!labelCloseable) {
        return false;
      }
      if(this.getLabel()){
        newMarker.setLabel();
        isOpenLable = false;
      } else {
        newMarker.setLabel(currentLable);
        isOpenLable = true;
      }
    });

    newMarker.on('moving', function(e: any) {
      if (e.passedPath.length > 1) {
        // const lastPoint = e.passedPath[e.passedPath.length - 1];
        // const lng = lastPoint.lng;
        // const lat = lastPoint.lat;
        // let currentIndex = -1;
        /**回传当前的索引值，避免多点重复导致匹配错误 */
        const currentIndex = changePassedPath.length + e.passedPath.length - 1;
        props.onMoving && props.onMoving(currentIndex);
        isOpenLable && showTrackLabel && newMarker.setLabel({
          ...trackLabelOptions || {},
          content: `${timeOptions[currentIndex]}`,
          offset: markerOffset,
        });
        // path.forEach((item: any, index: number) => {
        //   if (lng === item.lng && lat === item.lat) {
        //     currentIndex = index;
        //     props.onMoving && props.onMoving(index);
        //     isOpenLable && showTrackLabel && newMarker.setLabel({
        //       ...trackLabelOptions || {},
        //       content: `${timeOptions[index]}`,
        //       offset: markerOffset,
        //     });
        //     return true;
        //   }
        // });
        // 回放
        if (isPlayBack && (currentIndex === path.length - 1)) {
          handleReturnStart();
        }
      }
      newPassedPolyline.setPath(changePassedPath.concat(e.passedPath));
    });

    if (props.markerHoverLabel) {
      // 设置hover显示marker名称
      newMarker.on('mouseover', (e: any) => {
        newMarker.setLabel(currentLable);
        newMarker.setTop(true);
      });
      newMarker.on('mouseout', (e: any) => {
        newMarker.setLabel();
        newMarker.setTop(false);
      });
    }
    /** 开始播放 */
    (newMarker as any).start = function() {
      handleReturnStart();
    };
    /** 暂停 */
    (newMarker as any).pause = function() {
      newMarker.pauseMove();
    };
    /** 恢复播放 */
    (newMarker as any).resume = function() {
      newMarker.resumeMove();
    };
    /** 改变进度，以path[]索引值为参数 */
    (newMarker as any).change = function(index: number) {
      
      // 规划路线、changePassedPath、setLabel
      if (index !== path.length - 1) {
        const newPath = path.slice(index - 1);
        newMarker.moveAlong(newPath, props.speed * speedScale);

        changePassedPath = path.slice(0, index+1);

        currentLable = {
          ...trackLabelOptions || {},
          content: `${timeOptions[index]}`,
          offset: markerOffset,
        };
        isOpenLable && showTrackLabel && newMarker.setLabel(currentLable);
      } else {
        handleReturnStart();
      }
      // 暂停
      newMarker.pauseMove();
      newPassedPolyline.setPath(changePassedPath);
    };

    (map as unknown as AMap.Map).add(newMarker);
    (map as unknown as AMap.Map).add(newPolyline);
    (map as unknown as AMap.Map).add(newPassedPolyline);
    (map as unknown as AMap.Map).setFitView();

    setMarker(newMarker);
    setPolyline(newPolyline);
    setPassedPolyline(newPassedPolyline);

    return () => {
      if (newMarker) {
        (map as unknown as AMap.Map).remove([newMarker]);
        (map as unknown as AMap.Map).remove([newPolyline]);
        (map as unknown as AMap.Map).remove([newPassedPolyline]);
      }
    };
  }, [map, markerOptions, polylineOptions, passedLineOptions]);

  const start = () => {
    marker && marker.start();
  }

  const resume = () => {
    marker && marker.resume();
  }

  const pause = () => {
    marker && marker.pause();
  }

  const stop = () => {
    marker && marker.start();
    marker && marker.pause();
  }

  const change = (index: number) => {
    marker && marker.change(index);
  }

  useImperativeHandle(ref, () => {
    return {
      start,
      pause,
      resume,
      stop,
      change,
    };
  });

  return null;
});

export default TrackHistory;
